import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectSuccessWebviewPaymentStatusModalViewState } from '../store/selectors';

const SERVICE_GROUPS = {
  WALLET: ['add_balance_custom', 'wallet'],
  BUMP: ['bump', 'bump3', 'bump5', 'bump10'],
  FEATURED: ['featured1', 'featured5', 'featured15', 'featured30'],
  ADS: [
    'ad',
    'five_ads',
    'five_paid_ads',
    'one_ad',
    'one_paid_ad',
    'twenty_ads',
    'twenty_paid_ads'
  ],
  INVOICE: ['pay_invoice'],
  PIN_RECOVERY: ['pin_recovery'],
  VIP: ['vip1', 'vip5', 'vip15', 'vip30']
};

export default () => {
  const { t } = useTranslation();

  const { isVisible: isOpenWebViewSuccessAlertModal, payment } = useSelector(
    selectSuccessWebviewPaymentStatusModalViewState
  );

  const onAcceptWebViewSuccessPaymentModal = () => {
    window.location.reload();
  };

  const getServiceGroup = serviceId => {
    if (!serviceId) return null;

    return Object.entries(SERVICE_GROUPS).find(([_, services]) =>
      services.includes(serviceId)
    )?.[0];
  };

  const getSuccessAlertModalTitle = serviceId => {
    const serviceGroup = getServiceGroup(serviceId);

    switch (serviceGroup) {
      case 'WALLET':
        return t('webview.alert_modal.wallet_and_balance_success_title');
      case 'BUMP':
        return t('webview.alert_modal.bump_success_title');
      case 'FEATURED':
        return t('webview.alert_modal.featured_success_title');
      case 'ADS':
        return t('webview.alert_modal.ad_success_title');
      case 'INVOICE':
        return t('webview.alert_modal.pay_invoice_success_title');
      case 'PIN_RECOVERY':
        return t('webview.alert_modal.pin_recovery_success_title');
      case 'VIP':
        return t('webview.alert_modal.vip_success_title');
      default:
        return t('webview.alert_modal.payment_success_done_title');
    }
  };

  const getSuccessAlertModalMessage = serviceId => {
    const serviceGroup = getServiceGroup(serviceId);

    switch (serviceGroup) {
      case 'WALLET':
        return t('webview.alert_modal.wallet_and_balance_success_message');
      case 'BUMP':
        return t('webview.alert_modal.bump_success_message');
      case 'FEATURED':
        return t('webview.alert_modal.featured_success_message');
      case 'ADS':
        return t('webview.alert_modal.ad_success_message');
      case 'INVOICE':
        return t('webview.alert_modal.pay_invoice_success_message');
      case 'VIP':
        return t('webview.alert_modal.vip_success_message');
      default:
        return '';
    }
  };

  const successWebViewAlertModalTitle = getSuccessAlertModalTitle(
    payment?.service_id
  );
  const successWebViewAlertModalMessage = getSuccessAlertModalMessage(
    payment?.service_id
  );

  return {
    isOpenWebViewSuccessAlertModal,
    onAcceptWebViewSuccessPaymentModal,
    successWebViewAlertModalTitle,
    successWebViewAlertModalMessage,
    payment
  };
};
